export async function convertLeadToClient(leadId) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;

  const res = await fetch(`${backendUrl}/api/clients/convert`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ leadId, clientId: leadId })
  });

  if (!res.ok) return { success: false };

  return await res.json();
}
